module.exports = __webpack_public_path__ + "img/media_20240408_224931_229558323708861200.514dc1bf.jpg";